export enum ContractStatus {
  NEW = 'NEW',
  CANCELLED = 'CANCELLED',
  DELAYED = 'DELAYED',
  AWAITS_WORK_DONE_STATUS = 'AWAITS_WORK_DONE_STATUS',
  AWAITS_PAYMENT = 'AWAITS_PAYMENT',
  PAID = 'PAID',
}
